var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconEftpos64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_17635)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 12.2025V53.6027L15.191 55.7937H20.7885L22.9795 53.6027H32.8485L35.0395 55.7937H40.7899L42.9809 53.6027V8.36694H16.8478L13 12.2025Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.275 18.7166H27.8689C27.1711 18.7166 26.6055 19.2822 26.6055 19.98V35.1408C26.6055 35.8385 27.1711 36.4042 27.8689 36.4042H55.275C55.9727 36.4042 56.5384 35.8385 56.5384 35.1408V19.98C56.5384 19.2822 55.9727 18.7166 55.275 18.7166Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5677 18.7166H55.2753C55.9731 18.7166 56.5387 19.2822 56.5387 19.98V35.1408C56.5387 35.8385 55.9731 36.4042 55.2753 36.4042H47.5677C47.2151 36.4042 46.8786 36.2568 46.6394 35.9977L38.8511 27.5604L46.6394 19.123C46.8786 18.8639 47.2151 18.7166 47.5677 18.7166Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_17635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconEftpos64);
export default __webpack_public_path__ + "static/media/pictogramBeaconEFTPOS64.3afa57c66d9b9ae9f3b66fd33fdcfac5.svg";
export { ForwardRef as ReactComponent };